<template>
    <div class="vx-card p-6">
        <div class="flex flex-wrap items-center">
            <div class="flex-grow">
                <span>Lịch sử & tình trạng xử lý các yêu cầu mở rộng, nâng cấp và gia hạn gói.</span>
            </div>
            <!-- ITEMS PER PAGE -->
            <Pagination
                :itemList="packageHistory"
                :currentPage="currentPage"
                :paginationPageSize="paginationPageSize"
                :gridApi="gridApi"
            />

            <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                      v-model="searchQuery"
                      @input="updateSearchQuery" placeholder="Tìm kiếm..."/>
        </div>
        <!-- AgGrid Table -->
        <ag-grid-vue style="height: 55vh"
                     ref="agGridTable"
                     :components="components"
                     :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table"
                     :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="packageHistory"
                     :animateRows="true"
                     :pagination="true"
                     :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                     :paginationPageSize="paginationPageSize"
                     :onGridReady="onGridReady"
                     :suppressPaginationPanel="true">
        </ag-grid-vue>

        <vs-pagination
            :total="totalPages"
            :max="maxPageNumbers"
            v-model="currentPage"/>
    </div>
</template>

<script>
    import {AgGridVue} from "ag-grid-vue"
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import Pagination from "../../ui-elements/Pagination.vue"
    import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
    import CellRendererStatus from "./cell-renderer/CellRendererStatus";
    import moment from 'moment'

    export default {
        components: {
            AgGridVue,

            // Cell Renderer
            CellRendererActions,
            Pagination,
            CellRendererStatus
        },
        data() {
            return {
                searchQuery: "",
                maxPageNumbers: 7,
                // AgGrid
                gridApi: null,
                gridOptions: {},
                defaultColDef: {},
                columnDefs: [
                    {
                        headerName: 'Tổ chức',
                        field: 'organizationName',
                        width: 200,
                    },
                    {
                        headerName: 'Tên gói phần mềm',
                        field: 'organizationPackageResponseDTO.packageName',
                        width: 200,
                    },
                    {
                        headerName: 'Ngày yêu cầu',
                        field: 'createdDate',
                        width: 200
                    },
                    {
                        headerName: 'Giá thành',
                        field: 'price',
                        width: 200
                    },
                    {
                        headerName: 'Trạng thái',
                        field: 'registerPackageStatus',
                        width: 200,
                        cellRendererFramework: 'CellRendererStatus'
                    },
                    {
                        headerName: 'Hành động',
                        field: 'actions',
                        width: 120,
                        cellRendererFramework: 'CellRendererActions',
                    },
                ],
                // Cell Renderer Components
                components: {
                    CellRendererActions,
                    CellRendererStatus
                },
                packageHistory: [],
                organizationList: [],
                branchId: null,
            }
        },
        async created() {
            await this.getOrganization();
            this.initScreen();
        },
        watch: {
            '$store.state.windowWidth'(val) {
                if (val <= 1024) {
                    this.maxPageNumbers = 5;
                } else {
                    this.maxPageNumbers = 7;
                }

                if (val > 1024) {
                    this.gridApi.sizeColumnsToFit();
                }
            },
            '$store.state.reduceButton'() {
                setTimeout(() => {
                    this.gridApi.sizeColumnsToFit();
                }, 650);
            },
            '$store.state.isUpdateOrgPackageRequestPackage'(val) {
                if (val) {
                    this.initScreen();
                    this.$store.commit('UPDATE_REQUEST_PACKAGE', false);
                }
            },
        },
        computed: {
            paginationPageSize() {
                if (this.gridApi) return this.gridApi.paginationGetPageSize();
                else return 20
            },
            totalPages() {
                if (this.gridApi) return this.gridApi.paginationGetTotalPages();
                else return 0
            },
            currentPage: {
                get() {
                    if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            }
        },
        methods: {
            updateSearchQuery(val) {
                this.gridApi.setGridOption('quickFilterText', val);
            },
            onGridReady() {
                if (this.$store.state.windowWidth <= 1024) {
                    this.maxPageNumbers = 5;
                } else {
                    this.maxPageNumbers = 7;
                }

                if (this.$store.state.windowWidth > 1024) {
                    this.gridApi.sizeColumnsToFit();
                }
            },
            initScreen() {
                this.$vs.loading();
                let url = '/organization-package-history/find-all';
                this.$crm.get(url).then((response) => {
                    this.packageHistory = response.data.map(x => {
                        let org = this.organizationList.find(org => org.id === x.organizationId);
                        x.organizationName = org ? org.name : "";
                        x.createdDate = moment(x.createdDate).format("DD/MM/YYYY HH:mm:ss");
                        x.price = x.organizationPackageResponseDTO.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                        return x;
                    })
                    this.$vs.loading.close();
                    setTimeout(() => {
                        if (this.$store.state.windowWidth > 1024) {
                            this.gridApi.sizeColumnsToFit();
                        }
                    }, 100);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            },

            getOrganization() {
                return new Promise(resolve => {
                    this.$vs.loading();
                    this.$oauth.post('/organization/admin/all').then((response) => {
                        this.organizationList = response.data;
                        this.$vs.loading.close();
                        resolve(true);
                    }).catch((err) => {
                        resolve(true);
                        this.$vs.loading.close();
                        return this.$vs.notify({
                            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        });
                    });
                });

            },
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
        }
    }
</script>

<style scoped>

</style>
